import React from "react";
import { Route, withRouter } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { TAGS_ONE_QUERY } from "Services/queries";
import HeaderWrapperContainer from "Containers/HeaderWrapperContainer";
import { LoadingV2 } from "ComponentsUI/Loading";
import { Redirect404 } from "ComponentsUI/Redirects";
import { inject } from "mobx-react";

const Wrapper = (props) => {
	let {
		rest: {
			match: {
				params: { tagCode },
			},
			route,
		},
		mainComponent: MainComponent,
		seoData,
		ApplicationModel: { routesModel },
	} = props;

	let filter = [`translit=${tagCode}`, "type=provider"];

	let tagsOneQuery = useQuery(TAGS_ONE_QUERY, {
		skip: !tagCode,
		variables: {
			filter: filter.join("&"),
		},
	});
	if (!!tagCode && tagsOneQuery.loading) {
		return <LoadingV2 show={true} />;
	}

	let tagsOne = tagsOneQuery?.data?.tagsOne || null;
	if (!!tagCode && !tagsOne) {
		return <Redirect404 message404={"Отсутствует тег тарифа в регионе в обертке"} />;
	}
	routesModel.setTag(tagsOne);
	return (
		<HeaderWrapperContainer seoData={seoData} route={route}>
			<MainComponent route={route} />
		</HeaderWrapperContainer>
	);
};

const TariffLayout = ({ component: Component, seoData, ApplicationModel, ...rest }) => {
	return (
		<Route
			{...rest}
			render={() => {
				return (
					<Wrapper
						seoData={seoData}
						rest={rest}
						mainComponent={Component}
						ApplicationModel={ApplicationModel}
					/>
				);
			}}
		/>
	);
};

export default withRouter(inject("ApplicationModel")(TariffLayout));
